/**
 * /enroll/$token — public enrollment wizard.
 *
 * Unauthenticated route. The token in the URL is the only
 * credential. We intentionally do NOT preload the enrollment
 * state in the route loader because (a) we want the wizard's
 * own state machine to own the validating → loaded transition,
 * (b) a prefetch failure at the loader layer routes through
 * the wrong error screen.
 */

import { createFileRoute } from "@tanstack/react-router";
import { EnrollmentPage } from "@/features/enrollment/pages/enrollment-page";

export const Route = createFileRoute("/enroll/$token")({
  component: EnrollmentPage,
});
